/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import * as Octokit from '@octokit/rest';
import {createOAuthAppAuth} from '@octokit/auth-oauth-app';

import {
  Response,
  SearchReposParams,
  SearchReposResponse,
} from '@octokit/rest';
import {Observable, from} from 'rxjs';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {appAuthentication, Authentication} from '@octokit/auth-oauth-app/dist-types/types';

@Injectable()
export class GithubService {
  private octokit: Octokit;

  constructor() {
    this.octokit = new Octokit();
  }

  public async authenticate(): Promise<string> {
    const auth = createOAuthAppAuth({
      clientId: environment.clientId,
      clientSecret: environment.clientSecret,
    });
    const appAuth: Authentication = await auth({
      type: 'oauth-app',
    });
    const token = (appAuth as appAuthentication).headers.authorization;
    this.octokit = new Octokit({auth: token});

    return token;
  }

  public getRepos(params: SearchReposParams): Observable<Response<SearchReposResponse>> {
    return from(this.octokit.search.repos(params));
  }
}
